var map = {
	"./add-circle.vue": "./src/components/icons/svg/add-circle.vue",
	"./ai-sparkle.vue": "./src/components/icons/svg/ai-sparkle.vue",
	"./ampliar.vue": "./src/components/icons/svg/ampliar.vue",
	"./analyze-market.vue": "./src/components/icons/svg/analyze-market.vue",
	"./aplicar.vue": "./src/components/icons/svg/aplicar.vue",
	"./arrange-square-2.vue": "./src/components/icons/svg/arrange-square-2.vue",
	"./arrow-down-light.vue": "./src/components/icons/svg/arrow-down-light.vue",
	"./arrow-down-new-ux.vue": "./src/components/icons/svg/arrow-down-new-ux.vue",
	"./arrow-left.vue": "./src/components/icons/svg/arrow-left.vue",
	"./arrow-swap-horizontal.vue": "./src/components/icons/svg/arrow-swap-horizontal.vue",
	"./arrow-up-light.vue": "./src/components/icons/svg/arrow-up-light.vue",
	"./arrow-up-line.vue": "./src/components/icons/svg/arrow-up-line.vue",
	"./arrow-up-new-ux.vue": "./src/components/icons/svg/arrow-up-new-ux.vue",
	"./audio-lines.vue": "./src/components/icons/svg/audio-lines.vue",
	"./available.vue": "./src/components/icons/svg/available.vue",
	"./await-validation.vue": "./src/components/icons/svg/await-validation.vue",
	"./base-office.vue": "./src/components/icons/svg/base-office.vue",
	"./bell.vue": "./src/components/icons/svg/bell.vue",
	"./book-cover.vue": "./src/components/icons/svg/book-cover.vue",
	"./book.vue": "./src/components/icons/svg/book.vue",
	"./brain-circuit.vue": "./src/components/icons/svg/brain-circuit.vue",
	"./brush.vue": "./src/components/icons/svg/brush.vue",
	"./building-solo.vue": "./src/components/icons/svg/building-solo.vue",
	"./calendar-add.vue": "./src/components/icons/svg/calendar-add.vue",
	"./calendar-check.vue": "./src/components/icons/svg/calendar-check.vue",
	"./calendar-edit.vue": "./src/components/icons/svg/calendar-edit.vue",
	"./calendar-filter.vue": "./src/components/icons/svg/calendar-filter.vue",
	"./calendar.vue": "./src/components/icons/svg/calendar.vue",
	"./call.vue": "./src/components/icons/svg/call.vue",
	"./campos-obrigatorios.vue": "./src/components/icons/svg/campos-obrigatorios.vue",
	"./card-tick.vue": "./src/components/icons/svg/card-tick.vue",
	"./card.vue": "./src/components/icons/svg/card.vue",
	"./categories.vue": "./src/components/icons/svg/categories.vue",
	"./category.vue": "./src/components/icons/svg/category.vue",
	"./chart-bar-new-ux.vue": "./src/components/icons/svg/chart-bar-new-ux.vue",
	"./chart-bar.vue": "./src/components/icons/svg/chart-bar.vue",
	"./chart-finance.vue": "./src/components/icons/svg/chart-finance.vue",
	"./chart-grow.vue": "./src/components/icons/svg/chart-grow.vue",
	"./chart-vertical-new-ux.vue": "./src/components/icons/svg/chart-vertical-new-ux.vue",
	"./chats.vue": "./src/components/icons/svg/chats.vue",
	"./check-circle.vue": "./src/components/icons/svg/check-circle.vue",
	"./check.vue": "./src/components/icons/svg/check.vue",
	"./chevron-left.vue": "./src/components/icons/svg/chevron-left.vue",
	"./chevron-right.vue": "./src/components/icons/svg/chevron-right.vue",
	"./cipher-dollar-circle.vue": "./src/components/icons/svg/cipher-dollar-circle.vue",
	"./classe.vue": "./src/components/icons/svg/classe.vue",
	"./clipboard-text.vue": "./src/components/icons/svg/clipboard-text.vue",
	"./clock-filled.vue": "./src/components/icons/svg/clock-filled.vue",
	"./clock.vue": "./src/components/icons/svg/clock.vue",
	"./close-circle.vue": "./src/components/icons/svg/close-circle.vue",
	"./close.vue": "./src/components/icons/svg/close.vue",
	"./coin.vue": "./src/components/icons/svg/coin.vue",
	"./colunas-3.vue": "./src/components/icons/svg/colunas-3.vue",
	"./comments.vue": "./src/components/icons/svg/comments.vue",
	"./copy.vue": "./src/components/icons/svg/copy.vue",
	"./crm.vue": "./src/components/icons/svg/crm.vue",
	"./crown.vue": "./src/components/icons/svg/crown.vue",
	"./data.vue": "./src/components/icons/svg/data.vue",
	"./departments.vue": "./src/components/icons/svg/departments.vue",
	"./direct-inbox.vue": "./src/components/icons/svg/direct-inbox.vue",
	"./direct-send.vue": "./src/components/icons/svg/direct-send.vue",
	"./directbox-default.vue": "./src/components/icons/svg/directbox-default.vue",
	"./directbox-receive.vue": "./src/components/icons/svg/directbox-receive.vue",
	"./dislike.vue": "./src/components/icons/svg/dislike.vue",
	"./document-download.vue": "./src/components/icons/svg/document-download.vue",
	"./document-historic.vue": "./src/components/icons/svg/document-historic.vue",
	"./document-plus.vue": "./src/components/icons/svg/document-plus.vue",
	"./document-simple.vue": "./src/components/icons/svg/document-simple.vue",
	"./document-text.vue": "./src/components/icons/svg/document-text.vue",
	"./document-upload.vue": "./src/components/icons/svg/document-upload.vue",
	"./document.vue": "./src/components/icons/svg/document.vue",
	"./dolar.vue": "./src/components/icons/svg/dolar.vue",
	"./dollar-circle.vue": "./src/components/icons/svg/dollar-circle.vue",
	"./dollar-square.vue": "./src/components/icons/svg/dollar-square.vue",
	"./donut.vue": "./src/components/icons/svg/donut.vue",
	"./dot-pattern-background.vue": "./src/components/icons/svg/dot-pattern-background.vue",
	"./dots-inline.vue": "./src/components/icons/svg/dots-inline.vue",
	"./download.vue": "./src/components/icons/svg/download.vue",
	"./edit-2.vue": "./src/components/icons/svg/edit-2.vue",
	"./edit-pencil.vue": "./src/components/icons/svg/edit-pencil.vue",
	"./edit.vue": "./src/components/icons/svg/edit.vue",
	"./email.vue": "./src/components/icons/svg/email.vue",
	"./empty.vue": "./src/components/icons/svg/empty.vue",
	"./error-advice.vue": "./src/components/icons/svg/error-advice.vue",
	"./error-circle.vue": "./src/components/icons/svg/error-circle.vue",
	"./error-close.vue": "./src/components/icons/svg/error-close.vue",
	"./error-v2.vue": "./src/components/icons/svg/error-v2.vue",
	"./excel-logo.vue": "./src/components/icons/svg/excel-logo.vue",
	"./exercised.vue": "./src/components/icons/svg/exercised.vue",
	"./export-rounded.vue": "./src/components/icons/svg/export-rounded.vue",
	"./export.vue": "./src/components/icons/svg/export.vue",
	"./eye-close.vue": "./src/components/icons/svg/eye-close.vue",
	"./eye-slash.vue": "./src/components/icons/svg/eye-slash.vue",
	"./eye.vue": "./src/components/icons/svg/eye.vue",
	"./family-group.vue": "./src/components/icons/svg/family-group.vue",
	"./filial-segmentation.vue": "./src/components/icons/svg/filial-segmentation.vue",
	"./filter-new-ux.vue": "./src/components/icons/svg/filter-new-ux.vue",
	"./filtro-negativo.vue": "./src/components/icons/svg/filtro-negativo.vue",
	"./filtro-positivo.vue": "./src/components/icons/svg/filtro-positivo.vue",
	"./filtro-two-lines-positivo.vue": "./src/components/icons/svg/filtro-two-lines-positivo.vue",
	"./flash.vue": "./src/components/icons/svg/flash.vue",
	"./folder-add-outline.vue": "./src/components/icons/svg/folder-add-outline.vue",
	"./folder-add.vue": "./src/components/icons/svg/folder-add.vue",
	"./folder-cloud.vue": "./src/components/icons/svg/folder-cloud.vue",
	"./folder-outline.vue": "./src/components/icons/svg/folder-outline.vue",
	"./folder.vue": "./src/components/icons/svg/folder.vue",
	"./form-valuation.vue": "./src/components/icons/svg/form-valuation.vue",
	"./fornecedor.vue": "./src/components/icons/svg/fornecedor.vue",
	"./four-dots.vue": "./src/components/icons/svg/four-dots.vue",
	"./fp-briefcase.vue": "./src/components/icons/svg/fp-briefcase.vue",
	"./fp-car.vue": "./src/components/icons/svg/fp-car.vue",
	"./fp-cart.vue": "./src/components/icons/svg/fp-cart.vue",
	"./fp-food.vue": "./src/components/icons/svg/fp-food.vue",
	"./fp-gift.vue": "./src/components/icons/svg/fp-gift.vue",
	"./fp-pet.vue": "./src/components/icons/svg/fp-pet.vue",
	"./fp-travel.vue": "./src/components/icons/svg/fp-travel.vue",
	"./frequency.vue": "./src/components/icons/svg/frequency.vue",
	"./full-sort-up.vue": "./src/components/icons/svg/full-sort-up.vue",
	"./go-out.vue": "./src/components/icons/svg/go-out.vue",
	"./google.vue": "./src/components/icons/svg/google.vue",
	"./grafico-barra-new-ux.vue": "./src/components/icons/svg/grafico-barra-new-ux.vue",
	"./grafico-new-ux.vue": "./src/components/icons/svg/grafico-new-ux.vue",
	"./graph-pie.vue": "./src/components/icons/svg/graph-pie.vue",
	"./graphPizza-new-ux.vue": "./src/components/icons/svg/graphPizza-new-ux.vue",
	"./grid-six.vue": "./src/components/icons/svg/grid-six.vue",
	"./hearts.vue": "./src/components/icons/svg/hearts.vue",
	"./hierarchy-departments.vue": "./src/components/icons/svg/hierarchy-departments.vue",
	"./hierarchy.vue": "./src/components/icons/svg/hierarchy.vue",
	"./home-ia.vue": "./src/components/icons/svg/home-ia.vue",
	"./home-nav.vue": "./src/components/icons/svg/home-nav.vue",
	"./home.vue": "./src/components/icons/svg/home.vue",
	"./house.vue": "./src/components/icons/svg/house.vue",
	"./ia-head.vue": "./src/components/icons/svg/ia-head.vue",
	"./ia-imagem.vue": "./src/components/icons/svg/ia-imagem.vue",
	"./ia-w-mark.vue": "./src/components/icons/svg/ia-w-mark.vue",
	"./icon-positive-new-ux.vue": "./src/components/icons/svg/icon-positive-new-ux.vue",
	"./icon-sms.vue": "./src/components/icons/svg/icon-sms.vue",
	"./icons-math.vue": "./src/components/icons/svg/icons-math.vue",
	"./import-data.vue": "./src/components/icons/svg/import-data.vue",
	"./import.vue": "./src/components/icons/svg/import.vue",
	"./indicadores.vue": "./src/components/icons/svg/indicadores.vue",
	"./info-circle.vue": "./src/components/icons/svg/info-circle.vue",
	"./kanban.vue": "./src/components/icons/svg/kanban.vue",
	"./key-left.vue": "./src/components/icons/svg/key-left.vue",
	"./lamp-on.vue": "./src/components/icons/svg/lamp-on.vue",
	"./launcher.vue": "./src/components/icons/svg/launcher.vue",
	"./less.vue": "./src/components/icons/svg/less.vue",
	"./like.vue": "./src/components/icons/svg/like.vue",
	"./line-down.vue": "./src/components/icons/svg/line-down.vue",
	"./line-up-graph.vue": "./src/components/icons/svg/line-up-graph.vue",
	"./line-up.vue": "./src/components/icons/svg/line-up.vue",
	"./lock.vue": "./src/components/icons/svg/lock.vue",
	"./maximize.vue": "./src/components/icons/svg/maximize.vue",
	"./mdi-chart-timeline-variant.vue": "./src/components/icons/svg/mdi-chart-timeline-variant.vue",
	"./mdi-clipboard-list-outline.vue": "./src/components/icons/svg/mdi-clipboard-list-outline.vue",
	"./mdi-database.vue": "./src/components/icons/svg/mdi-database.vue",
	"./mdi-view-dashboard.vue": "./src/components/icons/svg/mdi-view-dashboard.vue",
	"./menu-board.vue": "./src/components/icons/svg/menu-board.vue",
	"./message-new-ux.vue": "./src/components/icons/svg/message-new-ux.vue",
	"./message-question.vue": "./src/components/icons/svg/message-question.vue",
	"./message-square.vue": "./src/components/icons/svg/message-square.vue",
	"./message-text.vue": "./src/components/icons/svg/message-text.vue",
	"./message-time.vue": "./src/components/icons/svg/message-time.vue",
	"./message.vue": "./src/components/icons/svg/message.vue",
	"./messages-2.vue": "./src/components/icons/svg/messages-2.vue",
	"./microphone-off.vue": "./src/components/icons/svg/microphone-off.vue",
	"./microphone.vue": "./src/components/icons/svg/microphone.vue",
	"./microsoft.vue": "./src/components/icons/svg/microsoft.vue",
	"./minus.vue": "./src/components/icons/svg/minus.vue",
	"./money-send.vue": "./src/components/icons/svg/money-send.vue",
	"./money-tick.vue": "./src/components/icons/svg/money-tick.vue",
	"./moneys.vue": "./src/components/icons/svg/moneys.vue",
	"./monitor.vue": "./src/components/icons/svg/monitor.vue",
	"./more.vue": "./src/components/icons/svg/more.vue",
	"./omie.vue": "./src/components/icons/svg/omie.vue",
	"./open-external.vue": "./src/components/icons/svg/open-external.vue",
	"./organograma-right.vue": "./src/components/icons/svg/organograma-right.vue",
	"./paperclip.vue": "./src/components/icons/svg/paperclip.vue",
	"./people-profile.vue": "./src/components/icons/svg/people-profile.vue",
	"./peoples.vue": "./src/components/icons/svg/peoples.vue",
	"./percentage-circle.vue": "./src/components/icons/svg/percentage-circle.vue",
	"./person-juridico.vue": "./src/components/icons/svg/person-juridico.vue",
	"./personalCard.vue": "./src/components/icons/svg/personalCard.vue",
	"./pie.vue": "./src/components/icons/svg/pie.vue",
	"./plus-line.vue": "./src/components/icons/svg/plus-line.vue",
	"./plus.vue": "./src/components/icons/svg/plus.vue",
	"./portabilidade.vue": "./src/components/icons/svg/portabilidade.vue",
	"./portifolio.vue": "./src/components/icons/svg/portifolio.vue",
	"./presentation-chart.vue": "./src/components/icons/svg/presentation-chart.vue",
	"./profile-circular-frame.vue": "./src/components/icons/svg/profile-circular-frame.vue",
	"./profile-new-ux.vue": "./src/components/icons/svg/profile-new-ux.vue",
	"./profile-pencil.vue": "./src/components/icons/svg/profile-pencil.vue",
	"./profile-tick.vue": "./src/components/icons/svg/profile-tick.vue",
	"./profile-two-user.vue": "./src/components/icons/svg/profile-two-user.vue",
	"./profissional-new-ux.vue": "./src/components/icons/svg/profissional-new-ux.vue",
	"./question.vue": "./src/components/icons/svg/question.vue",
	"./range-pl.vue": "./src/components/icons/svg/range-pl.vue",
	"./receipt-discount.vue": "./src/components/icons/svg/receipt-discount.vue",
	"./receipt-items.vue": "./src/components/icons/svg/receipt-items.vue",
	"./received-new-ux.vue": "./src/components/icons/svg/received-new-ux.vue",
	"./refresh-clock.vue": "./src/components/icons/svg/refresh-clock.vue",
	"./refresh.vue": "./src/components/icons/svg/refresh.vue",
	"./remove.vue": "./src/components/icons/svg/remove.vue",
	"./repeat-circle.vue": "./src/components/icons/svg/repeat-circle.vue",
	"./reserved.vue": "./src/components/icons/svg/reserved.vue",
	"./resgatar.vue": "./src/components/icons/svg/resgatar.vue",
	"./robot.vue": "./src/components/icons/svg/robot.vue",
	"./route-square.vue": "./src/components/icons/svg/route-square.vue",
	"./schedule.vue": "./src/components/icons/svg/schedule.vue",
	"./search-normal.vue": "./src/components/icons/svg/search-normal.vue",
	"./security-time.vue": "./src/components/icons/svg/security-time.vue",
	"./segmentation.vue": "./src/components/icons/svg/segmentation.vue",
	"./send-2.vue": "./src/components/icons/svg/send-2.vue",
	"./send-new-ux.vue": "./src/components/icons/svg/send-new-ux.vue",
	"./send-skinny-down.vue": "./src/components/icons/svg/send-skinny-down.vue",
	"./send-skinny-up.vue": "./src/components/icons/svg/send-skinny-up.vue",
	"./send.vue": "./src/components/icons/svg/send.vue",
	"./senioridade-new-ux.vue": "./src/components/icons/svg/senioridade-new-ux.vue",
	"./setting-outline.vue": "./src/components/icons/svg/setting-outline.vue",
	"./setting.vue": "./src/components/icons/svg/setting.vue",
	"./sheet.vue": "./src/components/icons/svg/sheet.vue",
	"./shield-user.vue": "./src/components/icons/svg/shield-user.vue",
	"./shoot.vue": "./src/components/icons/svg/shoot.vue",
	"./sidebar-bottom.vue": "./src/components/icons/svg/sidebar-bottom.vue",
	"./sidebar-top.vue": "./src/components/icons/svg/sidebar-top.vue",
	"./sms-edit.vue": "./src/components/icons/svg/sms-edit.vue",
	"./sms.vue": "./src/components/icons/svg/sms.vue",
	"./star-outlined.vue": "./src/components/icons/svg/star-outlined.vue",
	"./star.vue": "./src/components/icons/svg/star.vue",
	"./stars.vue": "./src/components/icons/svg/stars.vue",
	"./status-search.vue": "./src/components/icons/svg/status-search.vue",
	"./status-up.vue": "./src/components/icons/svg/status-up.vue",
	"./stop.vue": "./src/components/icons/svg/stop.vue",
	"./tag-right.vue": "./src/components/icons/svg/tag-right.vue",
	"./task-square.vue": "./src/components/icons/svg/task-square.vue",
	"./task.vue": "./src/components/icons/svg/task.vue",
	"./team-new-ux.vue": "./src/components/icons/svg/team-new-ux.vue",
	"./team.vue": "./src/components/icons/svg/team.vue",
	"./text-formatter.vue": "./src/components/icons/svg/text-formatter.vue",
	"./timer-warning.vue": "./src/components/icons/svg/timer-warning.vue",
	"./timer.vue": "./src/components/icons/svg/timer.vue",
	"./tipo.vue": "./src/components/icons/svg/tipo.vue",
	"./trash.vue": "./src/components/icons/svg/trash.vue",
	"./trend-up.vue": "./src/components/icons/svg/trend-up.vue",
	"./trocar.vue": "./src/components/icons/svg/trocar.vue",
	"./tune.vue": "./src/components/icons/svg/tune.vue",
	"./two-pop-chats.vue": "./src/components/icons/svg/two-pop-chats.vue",
	"./union-nav-bar.vue": "./src/components/icons/svg/union-nav-bar.vue",
	"./unlock.vue": "./src/components/icons/svg/unlock.vue",
	"./usd-circle.vue": "./src/components/icons/svg/usd-circle.vue",
	"./usd-square.vue": "./src/components/icons/svg/usd-square.vue",
	"./usd.vue": "./src/components/icons/svg/usd.vue",
	"./user-2.vue": "./src/components/icons/svg/user-2.vue",
	"./user-default.vue": "./src/components/icons/svg/user-default.vue",
	"./user-tag.vue": "./src/components/icons/svg/user-tag.vue",
	"./user.vue": "./src/components/icons/svg/user.vue",
	"./users.vue": "./src/components/icons/svg/users.vue",
	"./vestidas.vue": "./src/components/icons/svg/vestidas.vue",
	"./video.vue": "./src/components/icons/svg/video.vue",
	"./wallet-empty.vue": "./src/components/icons/svg/wallet-empty.vue",
	"./wallet.vue": "./src/components/icons/svg/wallet.vue",
	"./warning-circle.vue": "./src/components/icons/svg/warning-circle.vue",
	"./warning-status.vue": "./src/components/icons/svg/warning-status.vue",
	"./warning.vue": "./src/components/icons/svg/warning.vue",
	"./whatsapp.vue": "./src/components/icons/svg/whatsapp.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/icons/svg sync [\\w]+.vue$";